import React from "react";
import { useLocation } from "react-router-dom";

class ScrollToTop extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    window.scrollTo(0, 0);
  }

  render() {
    const { children } = this.props;
    return children || null;
  }
}

export default ScrollToTop;



// WEBPACK FOOTER //
// ./src/components/Common/ScrollToTop/index.js